export default "__VITE_ASSET__5e1095b2__"